import { render, staticRenderFns } from "./CardBodyItemCustom.vue?vue&type=template&id=9f949016&scoped=true"
import script from "./CardBodyItemCustom.vue?vue&type=script&lang=ts"
export * from "./CardBodyItemCustom.vue?vue&type=script&lang=ts"
import style0 from "./CardBodyItemCustom.vue?vue&type=style&index=0&id=9f949016&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f949016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f949016')) {
      api.createRecord('9f949016', component.options)
    } else {
      api.reload('9f949016', component.options)
    }
    module.hot.accept("./CardBodyItemCustom.vue?vue&type=template&id=9f949016&scoped=true", function () {
      api.rerender('9f949016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardBodyItemCustom.vue"
export default component.exports